import { css } from '@emotion/react'
import { useState } from 'react'

import { typo } from '~/@common/styles'
import Button from '~/@common/ui/(Button)/Button/Button'
import CheckboxInputLabel from '~/@common/ui/checkbox/CheckboxInputLabel'

type Props = {
  onConfirm: (skipNext: boolean) => void
  onCancel: () => void
}

export const CasBackConfirmModal = ({ onConfirm, onCancel }: Props) => {
  const [skipNext, setSkipNext] = useState(false)

  return (
    <>
      <div css={S.wrapper}>
        <p css={S.message}>
          다시 접속해도 이어서 응시할 수 있어요.
          <br />
          응시 화면을 나가시겠어요?
        </p>
        <div css={S.buttonRow}>
          <Button
            theme="primary"
            size="small"
            className="subGray"
            onClick={onCancel}
            style={S.buttonStyle}
          >
            취소
          </Button>
          <Button
            theme="primary"
            size="small"
            onClick={() => onConfirm(skipNext)}
            style={S.buttonStyle}
          >
            확인
          </Button>
        </div>
      </div>
      <CheckboxInputLabel css={S.skipLabel} onChange={(e) => setSkipNext(e.target.checked)}>
        다시 보지 않기
      </CheckboxInputLabel>
    </>
  )
}

export const casBackConfirmModalOpt = {
  modalName: 'cas-back-confirm',
  hasCloseButton: false,
  modalStyle: {
    padding: '24px 22px',
  },
} as const

const S = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 310px;
    padding: 24px 22px;
  `,
  message: css`
    ${typo.body02};
    color: var(--Colors-Gray-900);
    text-align: center;
  `,
  buttonRow: css`
    display: flex;
    gap: 12px;
    width: 212px;
  `,
  buttonStyle: {
    flex: '1 0 0',
    height: 40,
    padding: 10,
    borderRadius: 10,
  } as const,
  skipLabel: css`
    position: absolute;
    bottom: -31px;
  `,
}
